import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cross",
  "use": "cross-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"cross\"><path d=\"M15 0a15 15 0 1015 15A15.017 15.017 0 0015 0zm5.785 18.858a1.364 1.364 0 11-1.929 1.928L15 16.928l-3.856 3.858a1.364 1.364 0 01-1.929-1.928L13.072 15l-3.857-3.858a1.364 1.364 0 111.929-1.928L15 13.072l3.856-3.858a1.364 1.364 0 111.929 1.928L16.928 15l3.857 3.858z\" fill=\"#000\" fill-rule=\"nonzero\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol